<template>
  <div>
    <template v-if="list.length>1">
      <div class="swiper-container" ref="floor1Swiper">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="(carousel, index) in list" :key="index">
            <div class="slide-box">
              <img :src="label?carousel[label]:carousel" />
              <slot :index="index" name="carousel"></slot>
            </div>
          </div>
        </div>
        <div class="swiper-pagination" v-if="isPagination"></div>
        <template v-if="isNavigator">
          <div class="swiper-button-prev"></div>
          <div class="swiper-button-next"></div>
        </template>
      </div>
    </template>
    <template v-else>
      <div class="slide-box">
        <img :src="label?list[0][label]:list[0]" alt="" />
        <slot :index="0" name="carousel"></slot>
      </div>
    </template>
  </div>
</template>
<script>
import Swiper from 'swiper';
export default {
    name: 'carousel',
    props: {
        isPagination: {
            type: Boolean,
            default: true
        },
        isNavigator: {
            type: Boolean,
            default: true
        },
        list: {
            type: Array,
            default: () => []
        },
        loop: {
            type: Boolean,
            default: true
        },
        autotime: {
            type: Number,
            default: 3000
        },
        label: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
        }
    },
    mounted() {
        if(this.list.length<=1){
            return;
        }
        this.$nextTick(() => {
            new Swiper(this.$refs.floor1Swiper, {
                loop: this.loop, // 循环模式选项
                autoplay: {
                    delay: this.autotime,
                },
                // 如果需要分页器
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,//设置小原店面可以切换
                },
                // 如果需要前进后退按钮
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                // 如果需要滚动条
                scrollbar: {
                    el: '.swiper-scrollbar',
                },
                watchSlidesProgress: true,
                watchSlidesVisibility: true,
                on: {
                  touchMove: function () {
                    console.log('touchMove')
                  }
                }
            })
            // document.addEventListener('touchmove', function (e) {
            //   e.preventDefault()
            // }, { passive: false })
        })
    },
    methods: {

    }
}
</script>
<style scoped>
.swiper-container {
    --swiper-pagination-color: #e62129;
    --swiper-theme-color:#ffffff;
    --swiper-navigation-size:40px;
    height: 46vw;
}
.swiper-slide {
 transform: translateZ(0); 
}
.slide-box{
    position: relative;
    width: 100%;
    height: 100%;
}
.slide-box img {
  object-fit: cover;
  height: 46vw;
}
::v-deep .swiper-pagination-bullet {
    background: #b2b2b2;
    opacity: 1;
}
::v-deep .swiper-pagination-bullet-active {
    background: #e62129;
}
::v-deep .swiper-button-next{
  right: 30px;
}
::v-deep .swiper-button-prev{
  left: 30px;
}
</style>
